import { useEffect, useState } from 'react';
import { usePlacesAutocomplete } from './usePlacesAutoComplete';

export const usePostCode = () => {
    const { selectedPlaceDetails } = usePlacesAutocomplete();
    const [postCode, setPostCode] = useState<string | undefined>();

    useEffect(() => {
        if (!selectedPlaceDetails) {
            setPostCode(undefined);
            return;
        }

        const { address_components, geometry } = selectedPlaceDetails;

        const postalComponent = address_components.find((component) =>
            component.types.includes('postal_code')
        );

        if (postalComponent) {
            setPostCode(postalComponent.short_name);
            return;
        }

        if (geometry?.location) {
            const geocoder = new google.maps.Geocoder();
            geocoder.geocode(
                { location: geometry.location },
                (results, status) => {
                    if (status === 'OK' && results && results.length > 0) {
                        const reversePostal =
                            results[0].address_components.find((comp) =>
                                comp.types.includes('postal_code')
                            );
                        setPostCode(reversePostal?.short_name);
                    } else {
                        setPostCode(undefined);
                    }
                }
            );
        } else {
            setPostCode(undefined);
        }
    }, [selectedPlaceDetails]);

    return postCode;
};
